<template>
  <ion-page>
    <ion-tabs>
      <ion-router-outlet id="content"></ion-router-outlet>
      <ion-tab-bar slot="bottom" class="navbar">
        <ion-tab-button
          class="tab-button"
          :selected="path == route.path"
          v-for="route in routes1"
          :key="route.id"
          :tab="route.id"
          @click="router.push(route.path)"
          layout="icon-top"
        >
          <ion-icon :icon="route.icon" />
          {{ console.log(route) }}
          <ion-text style="font-size: 12px">
            {{ route.label }}
          </ion-text>
        </ion-tab-button>
        <ion-tab-button
          class="tab-button"
          tab="scan"
          @click="handleScan()"
          layout="icon-top"
        >
          <!-- <img src="assets/scan_button.png" />
           -->
          <img src="@/assets/images/icon_trans.png" style="max-height: 40px" />
          <ion-label style="font-size: 12px"> Scan </ion-label>
        </ion-tab-button>
        <ion-tab-button
          class="tab-button"
          :selected="path == 'shop'"
          key="shop"
          tab="shop"
          @click="openShop()"
          layout="icon-top"
        >
          <ion-icon :icon="bagHandleOutline" />
          <ion-label style="font-size: 12px"> Shop </ion-label>
        </ion-tab-button>

        <ion-tab-button
          class="tab-button"
          :selected="path.indexOf('profile/') > 0 ? true : false"
          key="mysku"
          tab="mysku"
          @click="router.push(`/profile/${user?.id}`)"
          layout="icon-top"
        >
          <ion-icon :icon="personCircleOutline" />
          <ion-label style="font-size: 12px"> mySKU </ion-label>
        </ion-tab-button>
      </ion-tab-bar>
    </ion-tabs>
    <ion-menu side="start" menu-id="menu" content-id="content" class="menu">
      <ion-content>
        <div class="menu-content">
          <ion-icon class="close" :icon="closeOutline" @click="handleClose" />
          <div class="profile">
            <ion-img :src="user?.avatar" class="avatar" />
            <div>
              <p class="name" @click="router.push(`/profile/${user?.id}`)">
                {{ `${user?.firstName} ${user?.lastName}` }}
              </p>
              <p class="nickname">{{ user?.profile.nickName }}</p>
              <p
                class="goto-profile"
                @click="
                  router.push(`/profile/${user?.id}`);
                  handleClose();
                "
              >
                View Profile
              </p>
            </div>
          </div>
          <ul>
            <li
              @click="
                router.push('/tabs/explore');
                handleClose();
              "
            >
              Discover
            </li>
            <li
              @click="
                router.push('/influencerList');
                handleClose();
              "
            >
              Find Your Tribe
            </li>
            <li
              @click="
                router.push('/tabs/events');
                handleClose();
              "
            >
              Events
            </li>
            <li class="shop">
              <a href="https://beautysku.myshopify.com/" target="_blank"
                >Shop &nbsp;
              </a>
              <div>
                <i
                  class="fa-thin fa-arrow-up-right-from-square ion-text-right pull-right"
                ></i>
              </div>
            </li>
            <li @click="router.push('/setting-privacy')">
              Settings &amp; Privacy
            </li>
            <li @click="logout()">Logout</li>
          </ul>
          <p class="copyright">BeautySKU @2023 - Reserved</p>
        </div>
      </ion-content>
    </ion-menu>
  </ion-page>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";
import { useRouter } from "vue-router";
import {
  IonContent,
  IonLabel,
  IonText,
  IonTabBar,
  IonTabButton,
  IonTabs,
  IonPage,
  IonRouterOutlet,
  IonMenu,
  menuController,
  IonIcon,
  IonImg,
  onIonViewDidLeave,
  modalController,
  onIonViewWillEnter,
  isPlatform,
} from "@ionic/vue";
import {
  bagHandleOutline,
  closeOutline,
  globeOutline,
  homeOutline,
  menuOutline,
  personCircleOutline,
  scanOutline,
} from "ionicons/icons";
import { useUserStore } from "@/store/modules/user";
import { useProductStore } from "@/store/modules/product";
import ModalBarcodeScanResult from "./Product/ModalBarcodeScanResult.vue";
import {
  BarcodeFormat,
  BarcodeScanner,
} from "@capacitor-mlkit/barcode-scanning";
import ScanView from "@/components/Modal/ScanView.vue";

const shop_site = (path: string) => {
  window.location.href = path;
};
const router = useRouter();
const userStore = useUserStore();
const user = computed(() => userStore.user);
const path = computed(() => router.currentRoute.value.path);
const productStore = useProductStore();
const routes1 = computed(() => {
  return [
    {
      id: "home",
      label: "Home",
      icon: homeOutline,
      path: "/tabs/home",
    },
    {
      id: "explore",
      label: "Explore",
      icon: globeOutline,
      path: "/tabs/explore",
    },
  ];
});

const routes2 = computed(() => {
  return [
    {
      id: "mysku",
      label: "My SKU",
      icon: personCircleOutline,
      path: "/profile/" + user.value?.id,
    },
  ];
});

onIonViewWillEnter(() => {
  BarcodeScanner.isSupported().then((result) => {
    const isSupported = result.supported;
    console.log("isSupported==>", isSupported);
  });
});

onIonViewDidLeave(() => menuController.close("menu"));

const openShop = () => {
  window.open("https://beautysku.myshopify.com");
};

const logout = () => {
  userStore.axLogout();
  router.push("/login");
};

const handleClick = async (path: string) => {
  if (path !== "/tabs/menu" && path !== "/tabs/scan") {
    router.push(path);
    return;
  }
};
const handleClose = () => {
  menuController.close("menu");
};
const viewBarcodeResult = async (barcodeResult: any, isFromDB: boolean) => {
  const modal = await modalController.create({
    component: ModalBarcodeScanResult,
    componentProps: { barcodeResult, isFromDB },
  });
  modal.present();
};
const handleScan = async () => {
  try {
    const isAndroid = isPlatform("android");
    //Android Only:
    if (isAndroid) {
      const ress = await BarcodeScanner.isGoogleBarcodeScannerModuleAvailable();
      if (!ress.available) {
        await BarcodeScanner.installGoogleBarcodeScannerModule();
      }
    }

    const { barcodes } = await BarcodeScanner.scan({
      formats: [BarcodeFormat.Ean13, BarcodeFormat.UpcA, BarcodeFormat.UpcE],
    });
    const res = barcodes[0].rawValue;

    //const res = "9780200992930"

    if (res && res != "") {
      const ourDatabaseRes = await productStore.axApiBarcodeLookUp(res);
      if (ourDatabaseRes.id !== "0") {
        // const data = {
        //   id: ourDatabaseRes?.id,
        //   brand: ourDatabaseRes?.brand?.name,
        //   images: [ourDatabaseRes?.url],
        //   title: ourDatabaseRes?.title,
        //   description: ourDatabaseRes?.description,
        //   reviews: ourDatabaseRes?.reviews,
        //   status: ourDatabaseRes?.status,
        // };
        // await viewBarcodeResult(data, true);
        router.push(`/product-detail/${ourDatabaseRes.id}`);
      } else {
        const apiRes = await productStore.axProductBarcodeLookUp(res);
        await viewBarcodeResult(apiRes, false);
      }

      //const resModal = await modalController.create({component:'modalLINK',componentProps:'data: fetchRes'})
    } else {
      alert("Could not find barcode in system");

      const upc = "079400061256"; //"852412007388";

      // }
    }
  } catch (e) {
    alert("Could not find barcode in system");
  }
};
</script>
<style lang="scss" scoped>
@import "../theme/variables/typography";
@import "../theme/variables/_color.scss";

i {
  color: white;
}
.shop {
  display: flex;
  align-items: center;
  justify-content: space-between;
  a {
    @include text-16-400;
    text-decoration: none;
    color: #ffffff;
  }
}
.navbar {
  background: linear-gradient(115.26deg, #e179cb 7.66%, #d7df4d 112.44%);

  & .tab-button {
    color: white;
  }
}
.menu {
  .menu-content {
    position: relative;
    height: 100%;
    background: linear-gradient(163.41deg, #e179cb -5.77%, #d7df4d 105.77%);
    //background: #E179CB;
    padding: 100px 35px 25px 25px !important;

    .close {
      position: absolute;
      top: 20px;
      right: 25px;
      width: 24px;
      height: 24px;
      color: $white;
      cursor: pointer;
    }

    .profile {
      display: flex;
      align-items: center;
      margin-bottom: 75px;

      & > div {
        p {
          margin: 0px;
        }

        .name {
          @include large;
          color: $white;
        }

        .nickname {
          @include text-14-normal;
          color: $white;
          opacity: 0.8;
        }

        .email {
          @include large;
          color: $white;
          opacity: 0.8;
        }

        .goto-profile {
          margin-top: 10px;
          @include text-12-bold;
          color: $white;
          opacity: 0.5;
          text-decoration: underline;
        }
      }

      .avatar {
        width: 75px;
        height: 75px;
        flex-shrink: 0;
        margin-right: 15px;

        &::part(image) {
          border-radius: 100%;
        }
      }
    }

    ul {
      list-style: none;
      padding: 0;

      li {
        @include text-16-normal;
        line-height: 19px;
        display: flex;
        align-items: center;
        height: 48px;
        border-bottom: 1px solid #ffffff50;
        color: #ffffff;
      }
    }

    .copyright {
      @include text-16-normal;
      line-height: 19px;
      color: #ffffff;
      position: absolute;
      bottom: 25px;
      left: 25px;
    }
  }
}
</style>
